<template>
  <div class="comparison-view">
    <div class="comparison-header">
      <h2>{{ comparison.version1 }}</h2>
      <p-md-icon name="file-compare" size="lg" />
      <h2>{{ comparison.version2 }}</h2>
      <p-button title="Close" @click="$emit('close')">
        <p-md-icon name="close" />
        Close
      </p-button>
    </div>
    <div class="diff-content" v-html="comparison.html" />
  </div>
</template>

<script>
import MdIcon from '@/components/common/MdIcon';
import Button from '@/components/common/Button';

export default {
  components: {
    'p-md-icon': MdIcon,
    'p-button': Button
  },
  props: {
    comparison: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.comparison-view {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: var(--theme-surface);

  .comparison-header {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1rem;
    background: var(--theme-surface);
    border-bottom: 1px solid var(--theme-on-background-dark);
    flex-shrink: 0;

    h2 {
      color: var(--theme-on-surface);
      font-size: 1.2rem;
      font-weight: 600;
    }
  }

  .diff-content {
    flex: 1;
    overflow: auto;
    padding: 1rem;
    background: var(--theme-background);
  }
}

::v-deep .content-dif {
  padding: 3px;
  max-width: 1024px;

  &.hidden {
    display: none;
  }
}

::v-deep .added {
  background-color: var(--theme-primary-light);
  color: var(--theme-on-primary);
}

::v-deep .deleted {
  background-color: var(--theme-danger-light);
  text-decoration: line-through;
}

::v-deep .jsondiffpatch-property-name {
  color: var(--theme-on-surface);
}

::v-deep .jsondiffpatch-value {
  color: var(--theme-on-surface);

  pre {
    max-width: 1024px;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
}

::v-deep .jsondiffpatch-added,
::v-deep .jsondiffpatch-deleted {
  background-color: transparent;
}

::v-deep .jsondiffpatch-added .jsondiffpatch-property-name,
::v-deep .jsondiffpatch-deleted .jsondiffpatch-property-name {
  background-color: transparent;
}

::v-deep .jsondiffpatch-deleted {
  div {
    background-color: var(--theme-danger-light);
  }
  pre {
    background-color: var(--theme-danger-light);
  }
}

::v-deep .jsondiffpatch-added {
  div {
    background-color: var(--theme-primary-light);
    color: var(--theme-on-primary);
  }
  pre {
    background-color: var(--theme-primary-light);
    color: var(--theme-on-primary);
  }
}

::v-deep .jsondiffpatch-modified {
  .jsondiffpatch-value.jsondiffpatch-left-value {
    pre {
      background-color: var(--theme-danger-light);
      color: var(--theme-on-primary);
    }
  }
  .jsondiffpatch-value.jsondiffpatch-right-value {
    pre {
      background-color: var(--theme-primary-light);
      color: var(--theme-on-primary);
    }
  }
}

::v-deep .jsondiffpatch-right-value {
  &.jsondiffpatch-value {
    color: var(--theme-surface);
  }
  div {
    color: var(--theme-on-surface);
  }
  pre {
    white-space: pre-wrap;
    max-width: 500px;
  }
}

::v-deep .jsondiffpatch-left-value {
  &.jsondiffpatch-value {
    color: var(--theme-surface);
  }
  div {
    color: var(--theme-on-surface);
  }
}
</style>
